import { useTranslation } from "react-i18next";
//import cn from "classnames";
import { Accordeon } from "@components/new/Accordeon";
import { Badge, BadgeType } from "@components/new/Badge";
import { Marketplace } from "@components/new/Marketplace";
import { H4, Title2, SubTitle2, SubTitle3 } from "@components/new/Typo";
// import { Button, ButtonSize, ButtonType } from "@components/new/Button";
// import { IconButton, IconButtonSize, IconButtonType } from "@components/new/IconButton";
import {
  TBlockingReason,
} from "@api/apiClient/fbp";
import styles from './Form.module.scss';

const BlockingReasons = ({
  warehouses,
}: {
  warehouses: {
    id: string;
    name: string;
    blockingReasons: TBlockingReason[];
    marketplace: string;
  }[];
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.form}>
      <div className={styles.title}>
        <H4>{t('fbpPage.delStoreModal.blockingTitle')}</H4>
        <SubTitle3 color="grey-800">
          {t('fbpPage.delStoreModal.blockingDescription')}
        </SubTitle3>
      </div>

      <Accordeon
        items={warehouses.map(v => ({
          id: v.id,
          title: (
            <div className={styles.reasonHeader}>
              <Marketplace name={v.marketplace} size="small" />
              <div className={styles.reasonHeader}>
                <Title2>{v.name}</Title2>
                <Badge type={BadgeType.DESTRUCTIVE}>
                  {t(`fbpPage.delStoreModal.reasonsCounter`, { count: v.blockingReasons?.length ?? 0 })}
                </Badge>
              </div>
            </div>
          ),
          content: (
            <div className={styles.reasonContent}>
              {(v.blockingReasons || []).map((reason) => (
                <div key={reason.reason} className={styles.reasonContentItem}>
                  <SubTitle2>{t(`fbpPage.delStoreModal.blockingReason.${reason.reason}`)}</SubTitle2>
                  <div className={styles.reasonContentNumbers}>
                    <SubTitle3 color="grey-800">{t("fbpPage.delStoreModal.blockingReasonNumbers", { context: reason.reason })}:</SubTitle3>
                    <SubTitle3 color="grey-800">{(reason.blockedNumbers || []).join(", ")}</SubTitle3>
                  </div>
                </div>
              ))}
            </div>
          ),
        }))}
        className={styles.reasonAccordeon}
        summaryClassName={styles.reasonAccordeonSummary}
        contentClassName={styles.reasonAccordeonContent}
        hideNumber
      />
    </div>
  );
};

export default BlockingReasons;
